<template>
  <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }">
    <b-form-group>
      <b-form-checkbox v-model="inputVal"
                       :state="state(errors)"
                       :required="required"
                       :disabled="disabled"
      >
        <slot></slot>
      </b-form-checkbox>
      <b-form-invalid-feedback :state="state(errors)">
        {{ errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import {
  BFormGroup,
  BFormCheckbox,
  BFormInvalidFeedback,
} from 'bootstrap-vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  mixins: [agcFormElementMixin],
  components: {
    BFormGroup,
    BFormCheckbox,
    BFormInvalidFeedback,
  },
};
</script>

<style scoped>

::v-deep .custom-control-input:focus ~ .custom-control-label::before{
  box-shadow: none !important;
  border: #adb5bd solid 1px;
}
</style>
